import PropTypes from 'prop-types';
import React from 'react';

import * as styles from './CallToAction.module.css';
import Form from './DynamicForm/Form';
import MarketoForm from './MarketoForm/MarketoForm';
import RichTextConverter from './RichText/RichTextConverter';

const CallToAction = ({ copy, formId, form }) => {
  const programName = form?.marketoProgramName;
  let formComponent;
  if (programName) {
    formComponent = <Form form={form.marketoForm} programName={form.marketoProgramName} />;
  } else {
    formComponent = <MarketoForm splitName formId={formId || ''} />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.ctaContent}>
        <RichTextConverter copy={copy} />
      </div>
      <div className={styles.form}>{formComponent}</div>
    </div>
  );
};

CallToAction.propTypes = {
  heading: PropTypes.string.isRequired,
  copy: PropTypes.object.isRequired,
  formId: PropTypes.string,
};

export default CallToAction;
